{
  "status": {
    "pending": "Belum Selesai",
    "preliminary": "Sementara",
    "final": "Muktamad",
    "corrected": "Dipinda",
    "amended": "Ditambah",
    "addended": "Dengan Adendum",
    "enteredInError": "Salah Kemasukan",
    "unknown": "Tidak Diketahui"
  },
  "review": {
    "title": "Semakan Keputusan",
    "printLabel": "Cetak Keputusan",
    "summary": {
      "count_one": "{{count}} keputusan",
      "count_other": "{{count}} keputusan",
      "criticalUnacknowledged": "{{count}} nilai kritikal belum diakui"
    },
    "view": {
      "timeline": "Garis Masa",
      "flowsheet": "Helaian Aliran"
    },
    "filter": {
      "date": "Tarikh",
      "type": "Jenis",
      "status": "Status",
      "statusAll": "Semua"
    },
    "dateRange": {
      "h24": "24 jam lalu",
      "h48": "48 jam lalu",
      "d7": "7 hari lalu",
      "d30": "30 hari lalu",
      "all": "Semua"
    },
    "resultType": {
      "all": "Semua",
      "lab": "Makmal",
      "imaging": "Pengimejan",
      "pathology": "Patologi",
      "cardiology": "Kardiologi",
      "microbiology": "Mikrobiologi"
    },
    "criticalOnlyToggle": "Kritikal Sahaja",
    "criticalBadge": "KRITIKAL",
    "actions": {
      "acknowledgeCritical": "Akui Kritikal",
      "acknowledgeAllCritical": "Akui semua kritikal ({{count}})"
    },
    "detail": {
      "resultNumber": "Nombor Keputusan",
      "performingProviderId": "ID Pelaksana",
      "verifiedByProviderId": "ID Pengesah",
      "verifiedAt": "Disahkan pada",
      "specimenCollected": "Spesimen Diambil",
      "clinicalSignificance": "Kepentingan Klinikal",
      "recommendations": "Cadangan",
      "report": "Laporan",
      "addendum": "Adendum",
      "criticalAcknowledged": "Nilai Kritikal Diakui",
      "providerHash": "Doktor #{{id}}",
      "acknowledgedAt": " pada {{when}}",
      "specimenType": "Jenis Spesimen",
      "grossDescription": "Penerangan Kasar",
      "microscopicDescription": "Penerangan Mikroskopik",
      "accessionNumber": "Nombor Aksesi",
      "bodyRegion": "Kawasan Badan",
      "studyInstanceUid": "Study Instance UID",
      "cardiologyMeasurements": "Ukuran",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "Memuatkan keputusan…",
    "loadError": "Gagal memuatkan keputusan. Sila cuba lagi.",
    "empty": "Tiada keputusan yang sepadan dengan penapis.",
    "toast": {
      "acknowledgeSuccess": "Nilai kritikal telah diakui",
      "acknowledgeError": "Gagal mengakui keputusan"
    },
    "susceptibility": {
      "title": "Organisma dan Kepekaan",
      "antibiotic": "Antibiotik",
      "interpretation": "Tafsiran",
      "mic": "MIC",
      "unnamedOrganism": "Organisma tanpa nama",
      "noPanel": "Tiada keputusan kepekaan dilaporkan bagi organisma ini."
    },
    "components": {
      "value": "Nilai",
      "referenceRange": "Julat Rujukan"
    }
  },
  "pending": {
    "title": "Keputusan Tertangguh",
    "countBadge_one": "{{count}} tertangguh",
    "countBadge_other": "{{count}} tertangguh",
    "autoRefresh": "Muat semula automatik {{seconds}}s",
    "updated": "Dikemas kini {{when}}",
    "searchPlaceholder": "Cari mengikut nama pesakit, MRN, atau pesanan…",
    "filtersButton": "Penapis",
    "fields": {
      "orderType": "Jenis Pesanan",
      "allTypes": "Semua Jenis",
      "priority": "Keutamaan",
      "allPriorities": "Semua Keutamaan",
      "dateFrom": "Dari Tarikh",
      "dateTo": "Hingga Tarikh"
    },
    "orderType": {
      "lab": "Makmal",
      "imaging": "Pengimejan",
      "procedure": "Prosedur",
      "consultation": "Rundingan",
      "laboratory": "Makmal Klinikal",
      "radiology": "Radiologi",
      "surgery": "Pembedahan",
      "therapy": "Terapi",
      "medication": "Ubat",
      "admission": "Kemasukan"
    },
    "aria": {
      "dateFrom": "Keputusan tertangguh dari tarikh",
      "dateTo": "Keputusan tertangguh hingga tarikh"
    },
    "columns": {
      "patient": "Pesakit",
      "mrn": "MRN",
      "order": "Pesanan",
      "type": "Jenis",
      "orderedBy": "Dipesan oleh",
      "ordered": "Masa Pesanan",
      "expected": "Dijangka",
      "priority": "Keutamaan"
    },
    "loading": "Memuatkan keputusan tertangguh…",
    "loadError": "Gagal memuatkan keputusan tertangguh",
    "retry": "Cuba lagi",
    "empty": "Tiada keputusan tertangguh.",
    "awaitingResult": "Menunggu keputusan",
    "specimenReceived": "Spesimen diterima",
    "inLab": "Di makmal",
    "cancelledByLab": "Dibatalkan oleh makmal",
    "overdue": "Tertunggak",
    "expectedBy": "Dijangka sebelum {{date}}"
  },
  "critical": {
    "title": "Keputusan Kritikal",
    "autoRefresh": "Muat semula automatik {{seconds}}s",
    "updated": "Dikemas kini {{when}}",
    "unacknowledgedHeading_one": "{{count}} Nilai Kritikal Belum Diakui",
    "unacknowledgedHeading_other": "{{count}} Nilai Kritikal Belum Diakui",
    "escalationBanner": "Keputusan ini memerlukan pengakuan doktor dengan segera.",
    "acknowledgeWithinMinutes": "Akui dalam {{minutes}} minit",
    "routeBackToProvider": "Hantar semula kepada doktor pemesan",
    "attendingSignoff": "Memerlukan tandatangan doktor penyelia",
    "searchPlaceholder": "Cari mengikut pesakit atau nama ujian…",
    "showAcknowledgedToggle": "Tunjuk yang diakui",
    "escalationTime": "T+{{minutes}}min",
    "criticalFallback": "KRITIKAL",
    "loading": "Memuatkan keputusan kritikal…",
    "loadError": "Gagal memuatkan keputusan kritikal",
    "empty": "Tiada keputusan kritikal menunggu pengakuan.",
    "detailToggleLabel": "Tunjuk butiran keputusan",
    "openFullChart": "Buka rekod penuh",
    "columns": {
      "patient": "Pesakit",
      "mrn": "MRN",
      "test": "Ujian",
      "value": "Nilai",
      "impression": "Tanggapan",
      "resultTime": "Masa Keputusan",
      "escalation": "Eskalasi",
      "acknowledged": "Diakui",
      "actions": "Tindakan"
    },
    "actions": {
      "acknowledge": "Akui"
    },
    "toast": {
      "acknowledgeSuccess": "Nilai kritikal telah diakui",
      "acknowledgeError": "Gagal mengakui keputusan"
    },
    "refreshFailed": "Tidak dapat dimuat semula — memaparkan keputusan kritikal setakat {{when}}.",
    "incomplete": "Memaparkan {{shown}} daripada {{total}} keputusan kritikal. Senarai ini tidak lengkap."
  },
  "acknowledged": {
    "pending": "Menunggu pengakuan",
    "acknowledged": "Diakui",
    "escalated": "Dieskalasi",
    "expired": "Tempoh pengakuan tamat"
  },
  "flowsheet": {
    "analyte": "Analit",
    "empty": "Tiada analit makmal untuk dipaparkan",
    "emptyHint": "Laporan pengimejan, patologi dan mikrobiologi dipaparkan dalam paparan garis masa.",
    "trend": {
      "toggle": "Trend {{analyte}}",
      "referenceRange": "Rujukan {{range}}",
      "nonNumericOmitted_one": "{{count}} keputusan teks tidak diplot",
      "nonNumericOmitted_other": "{{count}} keputusan teks tidak diplot"
    }
  }
}
